class InfiniteScrollBlog extends HTMLElement {
  constructor() {
    super();
    this.currentPage = parseInt(this.dataset.currentPage) || 1;
    this.totalPages = parseInt(this.dataset.totalPages) || 1;
    this.isLoading = false;
    this.pageCache = [];
    this.nextPageToLoad = this.currentPage + 1;
    this.nextPageToInsert = this.currentPage + 1;
    
    this.blogUrl = this.getBlogUrl();
    this.currentTags = this.getCurrentTags();
    this.blogListWrapper = this.querySelector(".js-blog-list");
    this.loadMoreButton = this.querySelector(".js-load-more");
    window.blogPageCache = this.pageCache;


  }

  connectedCallback() {
    if (this.blogListWrapper && this.totalPages > this.currentPage) {
      this.init();
    }
    this.loadMoreButton?.addEventListener('click', () => {
      this.loadMoreButton.disabled = true;
      setTimeout(() => {
        this.insertNextPage();
        this.loadMoreButton.disabled = false;
      }, 500);
    });
  }

  getBlogUrl() {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/tagged/')) {
      return currentPath.split('/tagged/')[0];
    } else if (currentPath.includes('?')) {
      return currentPath.split('?')[0];
    }
    return currentPath;
  }

  getCurrentTags() {
    const currentPath = window.location.pathname;
    if (currentPath.includes('/tagged/')) {
      return currentPath.split('/tagged/')[1].split('?')[0];
    }
    return '';
  }

  init() {
    console.log('InfiniteScrollBlog initialized - pages', this.currentPage, 'to', this.totalPages);
    this.loadNextPages();
  }



  async loadNextPages() {
    if (this.isLoading || this.nextPageToLoad > this.totalPages) return;

    const existingPage = this.pageCache.find(page => page.pageNumber === this.nextPageToLoad);
    if (existingPage) {
      this.nextPageToLoad++;
      this.loadNextPages();
      return;
    }

    console.log('Loading page:', this.nextPageToLoad);
    this.isLoading = true;

    try {
      const url = this.buildPageUrl(this.nextPageToLoad);
      const response = await fetch(url, { headers: { Accept: "text/html" } });
      
      if (!response.ok) throw new Error(`Failed to load page: ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const blogListItems = parser.parseFromString(html, "text/html").querySelectorAll(".js-blog-list-item");

      if (blogListItems.length > 0) {
        this.pageCache.push({
          pageNumber: this.nextPageToLoad,
          blogListItems: blogListItems,
          inserted: false
        });
        console.log('Cached page:', this.nextPageToLoad);
        console.log('Cache:', this.pageCache.map(p => `${p.pageNumber}${p.inserted ? '✓' : ''}`).join(' '));
      }
    } catch (error) {
      console.error('Error loading page:', error);
    } finally {
      this.isLoading = false;
      this.nextPageToLoad++;
      setTimeout(() => this.loadNextPages(), 100);
    }
  }

  insertNextPage() {
    const pageToInsert = this.pageCache.find(page => 
      page.pageNumber === this.nextPageToInsert && !page.inserted
    );

    if (pageToInsert) {
      console.log('Inserting page:', this.nextPageToInsert);
      pageToInsert.blogListItems.forEach(item => {
        this.blogListWrapper.appendChild(item);
      });
      pageToInsert.inserted = true;
      this.nextPageToInsert++;
      if (this.nextPageToInsert > this.totalPages) {
        this.loadMoreButton.classList.add('ia-visibility-hidden');
      }
    }
  }

  buildPageUrl(pageNumber) {
    let url = this.blogUrl;
    if (this.currentTags) url += `/tagged/${this.currentTags}`;
    if (pageNumber > 1) url += `?page=${pageNumber}`;
    return url;
  }
}

customElements.define("infinite-scroll-blog", InfiniteScrollBlog);
